import {
  REQUEST_MY_EVENT_STREAMS,
  RECEIVE_MY_EVENT_STREAMS,
  REMOVE_MY_EVENT_STREAM,
  UPDATE_MY_EVENT_STREAM
} from './myEventsActions'
import { REQUEST_CREATE_STREAM, RECEIVE_CREATE_STREAM } from '../add-stream-dialog/addStreamDialogActions'
import { LOG_OUT } from '../../top-panel/authorized-controls/authorizationActions'

const initialState = {
  isLoading: true,
  streams: undefined
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MY_EVENT_STREAMS:
      return { ...initialState, isLoading: true }

    case RECEIVE_MY_EVENT_STREAMS:
      return {
        isLoading: false,
        streams: action.streams
      }

    case REQUEST_CREATE_STREAM:
      return {
        ...state, isLoading: true
      }

    case RECEIVE_CREATE_STREAM:
      return {
        isLoading: false,
        streams: [...state.streams, {
          ...action.streamData,
          id: action.streamId
        }]
      }
    case REMOVE_MY_EVENT_STREAM:
      return {
        ...state,
        streams: state.streams.filter(stream => (stream.id !== action.eventId))
      }
    case UPDATE_MY_EVENT_STREAM:
      return {
        ...state,
        streams: state.streams.map(stream => (stream.id === action.stream.streamId) ? action.stream : stream)
      }
    case LOG_OUT:
      return { ...initialState }
    default: return state
  }
}
